import { fetcher } from "utils";

type PostUsersStores = (params: { storeId: number }) => Promise<"">;

export const post__users__stores: PostUsersStores = params => fetcher.post("/users/stores", params);
